// Auto-generated mapping of all Sass components

import Sass_extend from "./sass_components/Sass_extend.jsx";
import Sass_import from "./sass_components/Sass_import.jsx";
import Sass_mixin from "./sass_components/Sass_mixin.jsx";
import Sass_Certificate from "./sass_components/Sass_Certificate.jsx";
import Sass_Color from "./sass_components/Sass_Color.jsx";
import Sass_HOME from "./sass_components/Sass_HOME.jsx";
import Sass_Installation from "./sass_components/Sass_Installation.jsx";
import Sass_Intro from "./sass_components/Sass_Intro.jsx";
import Sass_Introspection from "./sass_components/Sass_Introspection.jsx";
import Sass_List from "./sass_components/Sass_List.jsx";
import Sass_Map from "./sass_components/Sass_Map.jsx";
import Sass_Nesting from "./sass_components/Sass_Nesting.jsx";
import Sass_Numeric from "./sass_components/Sass_Numeric.jsx";
import Sass_Selector from "./sass_components/Sass_Selector.jsx";
import Sass_String from "./sass_components/Sass_String.jsx";
import Sass_Variables from "./sass_components/Sass_Variables.jsx";

const AllSassComponents = {
  "<Sass_extend />": Sass_extend,
  "<Sass_import />": Sass_import,
  "<Sass_mixin />": Sass_mixin,
  "<Sass_Certificate />": Sass_Certificate,
  "<Sass_Color />": Sass_Color,
  "<Sass_HOME />": Sass_HOME,
  "<Sass_Installation />": Sass_Installation,
  "<Sass_Intro />": Sass_Intro,
  "<Sass_Introspection />": Sass_Introspection,
  "<Sass_List />": Sass_List,
  "<Sass_Map />": Sass_Map,
  "<Sass_Nesting />": Sass_Nesting,
  "<Sass_Numeric />": Sass_Numeric,
  "<Sass_Selector />": Sass_Selector,
  "<Sass_String />": Sass_String,
  "<Sass_Variables />": Sass_Variables,
};

export default AllSassComponents;
